var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-text"},[(_vm.icon)?_c('BaseIcon',{attrs:{"type":_vm.icon}}):_vm._e(),_vm._t("default"),(_vm.isString)?_c('span',[_vm._v(_vm._s(_vm.text))]):_c('div',{staticClass:"icon-text__list"},_vm._l((_vm.text),function(item,index){return _c('span',{key:`text-${index}`},[_vm._v(_vm._s(item))])}),0)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }